import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { SettingsService } from '../../core/services/settings.service';
import { AuthService } from '../../core/services/auth.service';

@Component({
  selector: 'app-login',
  imports: [],
  standalone: true,
  templateUrl: './login.component.html',
  styleUrl: './login.component.css'
})
export class LoginComponent implements OnInit, OnDestroy {
  private stream: Subscription;

  constructor(
    public settingsService: SettingsService,
    private authService: AuthService,
    private router: Router
  ) {}

  public ngOnInit() {
    this.stream = this.authService.canActivateProtectedRoutes$.subscribe(
      (yes) => {
        if (yes) this.router.navigate(['dashboard']);
      }
    );
  }

  public ngOnDestroy() {
    this.stream.unsubscribe();
  }

  public login() {
    this.authService.login('/dashboard');
  }
}
